<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全巡查结果上报</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="活动状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.activityStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="巡查对象">
          <el-select v-model="formInline.target_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡查人员" prop="member_id">
          <el-select v-model="formInline.member_id" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text" label="活动状态" width="150"></custom-table-column>
        <custom-table-column prop="target_name" label="巡查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="member_name" label="巡查人员" width="200px">
          <template slot-scope="scope" v-if="scope.row.members">
            <el-tag v-for="(item, index) in scope.row.members" :key="index">{{ item.member_name }}</el-tag>
          </template>
        </custom-table-column>
        <custom-table-column prop="check_date" label="巡查日期" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 1 && JSON.stringify(scope.row.members).indexOf($store.state.userInfo.number) > -1"
              @click="handleEditNew(scope.row)" type="text" size="small">结果上报</el-button>
            <el-button v-if="scope.row.status == 2" @click="handleDetail(scope.row)" type="text"
              size="small">查看结果</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="结果上报" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="活动名称">
          <el-input v-model="ruleForm.name" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查日期">
          <el-date-picker type="date" placeholder="" disabled value-format="yyyy-MM-dd" v-model="ruleForm.check_date"
            style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="巡查对象">
          <el-input v-model="ruleForm.target_name" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查人员">
          <el-input v-model="ruleForm.member_names" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查内容">
          <el-input type="textarea" v-model="ruleForm.content" disabled :rows="5" placeholder=""
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查结果" prop="check_result">
          <el-radio-group v-model="ruleForm.check_result" style="width:532px;">
            <el-radio v-for="item in $store.state.syszt" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="add_win " v-if="ruleForm.check_result == 2">
          <p class="add_win_title">隐患上报</p>
          <div v-for="(item, index) in ruleForm.hazards" :key="index" class="add_win_body el-form">
            <el-form-item label="隐患等级" :prop="`hazards[${index}].level`">
              <el-radio-group v-model="item.level" style="width:512px;">
                <el-radio v-for="item in $store.state.yhlevel" :key="item.value" :label="item.value">{{ item.label
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="整改对象" prop="target_id" :prop="`hazards[${index}].target_id`">
              <el-select v-model="item.target_id" clearable multiple filterable :placeholder="`请选择`"
                style="width: 216px;">
                <el-option v-for="item in ruleForm.targets" :key="item.target_id" :label="item.target_name"
                  :value="item.target_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="限定整改日期" :prop="`hazards[${index}].rectification_limit_date`">
              <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd"
                v-model="item.rectification_limit_date" style="width: 196px;"
                :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
            <el-form-item label="隐患描述" :prop="`hazards[${index}].description`">
              <el-input type="textarea" v-model="item.description" :rows="5" placeholder="请输入"
                style="width:512px;"></el-input>
            </el-form-item>
            <el-form-item label="隐患图片" :prop="`hazards[${index}].image`" style="width:100%">
              <Uploadd ref="uploadd" :fileFieldNameIn="`hazards[${index}].image`" :isMultiple="true" btnTitle="点击上传图片"
                :uploadType="uploadType" @setFileList="setFileListMultiple" @delFile="delUpFile"></Uploadd>
            </el-form-item>
            <div class="add_win_del">
              <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
            </div>
          </div>
          <div class="add_win_add">
            <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="查看结果" :visible.sync="detailDialogVisible" width="846px">
      <SafeCheckRusult :rowObj="rowObj" />
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';
import SafeCheckRusult from "./components/safeCheckRusult";

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter, mixinUpload],
  data() {
    return {
      formInline: {
        name: '',
        status: '',
        target_id: '',
        member_id: '',
      },
      users: [],
      uploadType: 'image',
      detailDialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
        },
      },
      ruleForm: {
        name: '',
        check_date: '',
        target_name: '',
        member_names: '',
        content: '',
        check_result: 1,
        hazards: [{ "level": 1, "description": "", "image": "", "rectification_limit_date": "" }],
        targets: []
      },
      loading: false,
      rulesRoot: {
        check_result: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      rules: {},
      rowObj: {}
    };
  },
  components: {
    SafeCheckRusult
  },
  created() {
    this.$store.dispatch('getTarinMent');
    // 
  },
  mounted() {
    this.setRules()
  },
  methods: {
    generateArrRules() {
      const arrRules = {};
      this.ruleForm.hazards.forEach((item, index) => {
        arrRules[`hazards[${index}].target_id`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
        arrRules[`hazards[${index}].level`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
        arrRules[`hazards[${index}].rectification_limit_date`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
        arrRules[`hazards[${index}].description`] = [
          { required: true, message: `请输入`, trigger: 'blur' }
        ];
      });
      return arrRules;
    },
    handleDetail(row) {
      this.detailDialogVisible = true
      if (row.members && row.members.length > 0) {
        row.member_names = row.members ? row.members.map(item => item.member_name).join(',') : ''
      }
      this.rowObj = row
    },
    handleItemDelete(item, index) {
      this.ruleForm.hazards.splice(index, 1);
      this.setRules()
    },
    handleItemAdd() {
      this.ruleForm.hazards.push({ "level": 1, "description": "", "image": "", "rectification_limit_date": "" });
      this.setRules()
    },
    setRules() {
      this.rules = {
        ...this.rulesRoot,
        ...this.generateArrRules()
      };
    },
    handleEditNew(row, extraKeys = ['id']) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
      this.ruleForm.check_result = 1
      // this.ruleForm.target_id = row.target_id ? row.target_id.split(',') : []
      // this.remoteMethod(row.member_name, true)

      if (row.members && row.members.length > 0) {
        this.ruleForm.member_names = row.members ? row.members.map(item => item.member_name).join(',') : ''
      }
      this.centerDialogVisible = true;
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: 3
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safe-check-activity/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      delete params.targets
      if (params.hazards && params.hazards.length) {
        params.hazards.forEach(item => {
          if (item.target_id) {
            item.target_id = item.target_id.join(',')
          }
        })
      }
      // console.log(params)
      // return
      let res = await this.$api.instance.interfaceServer(`api/safe-check-activity/submit-report/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '上报成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
